@import (reference) '../../../styles/variables.less';

:host {
  font: @lt-font-primary;
}

.dropdown {
  &--root {
    position: relative;
  }

  &--label {
    color: @white;
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 5px;
  }

  &--current-selection {
    align-items: center;
    background-color: @white;
    border: 1px solid @lt-gray-dark-3;
    border-radius: 4px;
    color: @text-gray;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    line-height: 24px;
    padding: 9px 12px;
  }

  &--title {
    font-size: 21px;
    font-weight: bold;
    line-height: 30px;
    margin: 0;
  }

  &--options {
    background-color: @white;
    border-radius: 4px;
    box-shadow: @shadow-2;
    color: @text-gray;
    display: none;
    margin: 0 0 1px;
    overflow: auto;
    padding: 0;
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  &--option-item {
    cursor: pointer;
    font-size: 16px;
    line-height: 20px;
    padding: 14px 16px;

    &.dropdown--option-item-is-active,
    &:hover {
      background-color: @lt-blue-light-3;
    }
  }
}

:host(.dropdown--is-open) {
  .dropdown--options {
    display: block;
  }
}
